import { gsap } from 'gsap'
import { module } from 'modujs'
import { ENV } from '../config'

export default class extends module {
  constructor(m) {
    super(m)

    this.inner = this.el.querySelector('.o-introduction_inner')
    this.backgrounds = this.el.querySelector('.o-introduction_backgrounds')
    this.backgroundsItems = [...this.el.querySelectorAll('.o-introduction_background')]
    this.mask = this.el.querySelector('.o-introduction_mask')
    this.marquee = this.el.querySelector('.o-introduction_marquee')
    this.marqueeWrap = this.el.querySelector('.o-introduction_marquee_wrap')

    this.currentBgIndex = -1
    this.zindex = 1

    this.play = this.play.bind(this)

    window.addEventListener(
      'play-intro',
      this.play,
      { once: true }
    )
  }

  play() {
    setTimeout(() => {
      this.backgroundsRotator()
    }, 500)

    this.tl = gsap.timeline()

    if (navigator.userAgent.toLowerCase().includes('firefox')) {
      this.tl.to(this.marqueeWrap, {
        y: 0,
        duration: 0.8,
        ease: 'expo.out',
        delay: 1
      })
    }
    else {
      this.tl.to(this.inner, {
        scale: ENV.IS_SM
          ? 0.8
          : 0.3,
        duration: 1.4,
        ease: 'expo.out',
        delay: 2
      })
      this.tl.to(
        this.mask,
        {
          scale: 1,
          duration: 0.8,
          ease: 'expo.out'
        },
        '-=1.4'
      )
      this.tl.to(
        this.marqueeWrap,
        {
          y: 0,
          duration: 0.8,
          ease: 'expo.out'
        },
        '-=1.4'
      )
    }
  }

  backgroundsRotator() {
    const oldActiveIndex = this.currentBgIndex

    if (this.currentBgIndex === this.backgroundsItems.length - 1) {
      this.currentBgIndex = 0
    }
    else {
      this.currentBgIndex = this.currentBgIndex + 1
    }

    this.backgroundsItems[this.currentBgIndex].style.zIndex = this.zindex
    this.backgroundsItems[this.currentBgIndex].classList.add('-active')

    setTimeout(() => {
      this.backgrounds.classList.add('-animated')

      if (oldActiveIndex >= 0) {
        this.backgroundsItems[oldActiveIndex].classList.remove('-active')
      }
    }, 1200)

    setTimeout(() => {
      this.zindex++

      if (this.zindex < 9) {
        this.backgroundsRotator()
      }
      else {
        this.hideMedias()
      }
    }, 400)
  }

  hideMedias() {
    gsap.to(this.backgroundsItems, {
      opacity: 0,
      duration: 0.6,
      ease: 'none',
      onComplete: () => {
        setTimeout(() => {
          gsap.to(this.marquee, {
            opacity: 0,
            duration: 0.4,
            ease: 'none'
          })
          gsap.to(this.inner, {
            opacity: 0,
            duration: 0.8,
            ease: 'power4.out'
          })
          this.el.classList.add('-hidden')
          this.call('start', 'Scroll')

          this.backgrounds.querySelectorAll('video').forEach((v) => {
            v.pause()
          })

          setTimeout(() => {
            window.dispatchEvent(new Event('p-animate'))
          }, 700)
        }, 1000)
      }
    })
  }

  destroy() {
    window.removeEventListener('play-intro', this.play)
  }
}
